import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback, MessageAlert, Loader, DataTableHoc } from 'smart-react';
import { WEBHOOKLOGS } from '../../../constants/applicationConstants';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import { Card } from '@progress/kendo-react-layout';

import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../constants/applicationConstants';

import {
  deleteFilter,
  applyFilter,
  saveFilters,
} from '../../../Utils/Filters/filterSliderHandler';
import { getWebHookLogDetail } from '../Services/WebHookLogsService';
import { Dialog } from '@progress/kendo-react-dialogs';
import JsonPreviewer from '../../Core/Components/JsonPreviewer/JsonPreviewer';

const BaseWebHookLogsDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable')
);
const WebHookLogsDataTable = DataTableHoc(BaseWebHookLogsDataTable);

/**
 * AffectedFiles main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The AffectedFiles component.
 */
const WebHookLogs = () => {
  const [loading, setLoading] = useState(false);
  const [rolloutsData, setRolloutsData] = React.useState([]);
  const [visible, setVisible] = React.useState(false);
  const dataColumnsArray = DataColumns({});
  // const gridColumnsArray = () => GridColumnsList({ getWebhookDetail });
  const [logDetail, setLogDetail] = useState(null);

  const [alertMessage, setAlertMessage] = React.useState({
    alert: false,
    message: null,
  });
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  const toggleDialog = () => {
    setVisible(!visible);
  };
  /**
   * Description: get data from api and set on logDetail object
   * @param oisId int
   * @returns
   */
  const getWebhookDetail = async (oisId) => {
    let webHookId = oisId;
    setLoading(true);
    try {
      const response = await getWebHookLogDetail({ webHookId });
      if (response.isSuccess) {
        setLogDetail(response?.payload?.payload);
        setVisible(true);
      } else {
        setAlertMessage({
          alert: true,
          message: 'There is some issue with the download!',
        });
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching Web Hook Detail Logs:', error);
      setLoading(false);
    }
  };

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <React.Suspense fallback={<Loader />}>
        {loading && <Loader />}
        {alertMessage?.alert && (
          <MessageAlert
            type={'danger'}
            message={alertMessage.message}
            isIcon={true}
            iconName={'error'}
          />
        )}
        {visible && (
          <Dialog
            title={'Webhook Detail'}
            width={'80%'}
            height={'90%'}
            onClose={toggleDialog}
          >
            <JsonPreviewer jsonInput={JSON.stringify(logDetail)}/>
          </Dialog>
        )}
        <div className="container mx-auto account-form-container">
          <div className="add-test add-test-page cards-layout-page container mx-auto">
            <div className="card-detail-content">
              <Card className="seprate-card">
                <div className="card-content">
                  <WebHookLogsDataTable
                    deleteFilter={deleteFilter}
                    applyFilter={applyFilter}
                    saveFilters={saveFilters}
                    moduleName={WEBHOOKLOGS}
                    dataColumns={dataColumnsArray}
                    gridColumnsList={GridColumnsList}
                    dataTableName={WEBHOOKLOGS}
                    setIsReady={setIsReady}
                    isReady={isReady}
                    rowLayoutConfigName={`${WEBHOOKLOGS}.DataGrid.RowLayout`}
                    pageLengthConfigName={`${WEBHOOKLOGS}.DataGrid.ItemsPerPage`}
                    dataSet={rolloutsData}
                    setDataSet={setRolloutsData}
                    initialSort={{
                      field: 'rn',
                      dir: 'asc',
                    }}
                    isCardonMobileView={false}
                    total={process.env.DefaultLimit}
                    defaultRowLayout={process.env.RowLayout}
                    rowLayouts={ROW_LAYOUTS}
                    pageSizes={PAGE_SIZE}
                    getWebhookDetail={getWebhookDetail}
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </React.Suspense>
    </ErrorBoundary>
  );
};
export default WebHookLogs;
